/**
 * Debounces execution of the given function by the given wait time.
 * This is useful to limit execution of functions that can be
 * called repeatedly, like in scroll or input events.
 *
 * @param {Function} func - The function to debounce
 * @param {number} wait - The debounce time in ms
 * @returns {Function} The debounced function
 */
function debounceScroll(func, wait) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    const later = function () {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// function fixSidebarMenuPosition() {
//   if (document.querySelector("header").classList.contains("collapsed")) {
//     document.querySelectorAll('[data-name="side-bar-scroller"]').forEach((scroller) => {(scroller.style.paddingTop = "0")});
//   } else {
//     if (window.innerWidth < 1007) {
//       document
//         .querySelectorAll('[data-name="side-bar-scroller"]')
//         .forEach((scroller) => (scroller.style.paddingTop = "4.025rem"));
//     } else {
//       document
//         .querySelectorAll('[data-name="side-bar-scroller"]')
//         .forEach((scroller) => (scroller.style.paddingTop = "3.125rem"));
//     }
//   }
// }

fixSidebarMenuPosition();
window.addEventListener("scroll", debounceScroll(fixSidebarMenuPosition, 50));
